import { getEnvVar } from "./lib";


export const debugLog = (...args) => {
    if (getEnvVar('REACT_APP_ENV') === 'development' || getEnvVar('REACT_APP_ENV') === 'test') {
        console.log(...args);
    }
}